import "../../../styles/components/items/itemCardComponent.scss";
import noImage from "../../../assets/images/defaults/NoImage1.png";
import ItemCardShoppingCartActionsComponent from "./ItemCardShoppingCartActionsComponent";
import useAccount from "../../../hooks/useAccount";
import { Link, useNavigate } from "react-router-dom";

export const ItemCardComponent = ({ props }) => {
  const navigate = useNavigate();
  const { product, showMoreDetailsButton = true } = props;
  const { isLoggedIn, userInfo } = useAccount();

  return (
    <div className={`productCardContainer `}>
      <div className={`imageContainer ${!product.isAvailable ? "disabled" : ""}`}>
        <img src={product.pictureUrl ? product.pictureUrl : noImage} alt={product.itemDescription} loading="lazy" decoding="async" onError={(e) => (e.target.src = noImage)} />
        {!product.isAvailable && (
          <div className="unavailableSticker">
            <span>יחזור בקרוב</span>
          </div>
        )}
        {product.isPriceChanged && (
          <div className="priceChangeSticker">
            <span>שינוי במחיר</span>
          </div>
        )}
      </div>

      <h6 className="productName">{product.itemDescription}</h6>
      {isLoggedIn && <h5 className="price">₪{product.salePriceInNIS}</h5>}
      {isLoggedIn && <ItemCardShoppingCartActionsComponent props={props} />}
      {showMoreDetailsButton && (
        <Link className="primaryButton" to={`?d=item&itemId=${product.itemId}`}>
          פרטים נוספים
        </Link>
      )}
    </div>
  );
};

export default ItemCardComponent;
